import React from 'react';
import Cutouts from '../../components/Cutouts';
import TextAlignment from '../../components/TextAlignment';
import styles from './BlockSection.module.css';

/** @param {FF.ContentfulBlockSectionProps} props */
export default function BlockSection({
  children,
  className,
  cutouts,
  textAlignment,
}) {
  return (
    <Cutouts cutouts={cutouts}>
      <TextAlignment alignment={textAlignment} className={className}>
        <div className={styles.wrapper}>{children}</div>
      </TextAlignment>
    </Cutouts>
  );
}
